/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ActionAudFilterDto interface.
 */
export function instanceOfActionAudFilterDto(value) {
    return true;
}
export function ActionAudFilterDtoFromJSON(json) {
    return ActionAudFilterDtoFromJSONTyped(json, false);
}
export function ActionAudFilterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'page': json['page'] == null ? undefined : json['page'],
        'size': json['size'] == null ? undefined : json['size'],
        'dataInizio': json['dataInizio'] == null ? undefined : (new Date(json['dataInizio'])),
        'dataFine': json['dataFine'] == null ? undefined : (new Date(json['dataFine'])),
        'idUtente': json['idUtente'] == null ? undefined : json['idUtente'],
        'jsonFilter': json['jsonFilter'] == null ? undefined : json['jsonFilter'],
    };
}
export function ActionAudFilterDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'page': value['page'],
        'size': value['size'],
        'dataInizio': value['dataInizio'] == null ? undefined : ((value['dataInizio']).toISOString()),
        'dataFine': value['dataFine'] == null ? undefined : ((value['dataFine']).toISOString()),
        'idUtente': value['idUtente'],
        'jsonFilter': value['jsonFilter'],
    };
}
